import styled from 'styled-components';

export const Container = styled.section`
  margin: 0 auto;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 5rem - 21.875rem);
  @media (max-width: 768px) {
    height: calc(100vh - 4.5rem - 38.063rem);
  }
  & a {
    height: 3rem;
    width: 10rem;
    margin-top: 1rem;
  }
`;
